module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABE0lEQVQ4T6XTvSuFYRjH8c9hobBIFu8veYkom4kBpZQyK/+JxUY2i8z+Dn8DxWIRZWEiZXHrqns45+m5T6fOvTx1P7/re18vv6uhw5NSGsMkZjCLRQw2muNTSn0Yz6Ip3OEUm/m+p/peI6V0gi0sI4JGmkRHuMZwIdHXAPygvyDYwTnW2wEesFIj+MNeJ4B7rHYD+GhT4wFuMFooIUUPLjBRI0g4w3Fubh3jMwAbGEAEtEwV0Z+Ye/yvO78BeClkEAH7uMJ0AfAVgEcsFQS7uCxMKULeA9D1FJ6zt6tJdOyDp7wYdVVECeHEtXZODP/P5yzmctfDWHF/iFsMFQDfLdtY2cxY39iT7ezUgC8gvr1Z+/YPr8NhMB1PbeAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/icon-win-active.png
// module id = mp90
// module chunks = 0 1